

import { Nullable, Tag } from '@brg/api';
import { bTag } from '../../../../core';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTag {
    name: string;
    tagId: string;
    identifier: string;
    has: boolean;
    title: string;
    color?: string;
    contextEntityId?: string[];
    position: number;
    groupType?: string;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param tag
 */
export function computeTag(tag: Nullable<Partial<Tag>>): ComputedTag {
    return {
        name: tag ? bTag.title(tag as Tag) : 'unnamed',
        contextEntityId: tag ? (tag as any)['contextEntityId'] ?? [] : [],
        tagId: tag?.tagId ?? 'undefined',
        identifier: tag?.tagId ?? 'undefined',
        title: tag ? bTag.title(tag as Tag) : 'untitled',
        color: tag?.color,
        has: !!tag,
        position: tag?.position ?? 0,
        groupType: tag?.groupType,
    };
}


import { Nullable, Tag } from '@brg/api';
import { bTag } from '../../../../core';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedTag {
    name: string;
    tagId: string;
    identifier: string;
    has: boolean;
    title: string;
    color?: string;
    contextEntityId?: string[];
    position: number;
    groupType?: string;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param tag
 */
export function computeTag(tag: Nullable<Partial<Tag>>): ComputedTag {
    return {
        name: tag ? bTag.title(tag as Tag) : 'unnamed',
        contextEntityId: tag ? (tag as any)['contextEntityId'] ?? [] : [],
        tagId: tag?.tagId ?? 'undefined',
        identifier: tag?.tagId ?? 'undefined',
        title: tag ? bTag.title(tag as Tag) : 'untitled',
        color: tag?.color,
        has: !!tag,
        position: tag?.position ?? 0,
        groupType: tag?.groupType,
    };
}
